import React from "react";
import { Link } from "react-router-dom";
import NavItem from "../../../components/navigation/NavItem";
import ViewsDropdownMenu from "./navigation/ViewsDropdownMenu";

// layout
import { Header } from "../../../layout/Header";

// icons
import { List } from "lucide-react";
import suitcasePng from "../assets/images/suitcase.png";

const ViewsHeader = ({ tale = {}, taleId = "" }) => {
  return (
    <Header
      className="app-header fixed-top"
      size="md"
      start={
        <div className="w-20 d-flex flex-column align-items-center">
          <NavItem icon={<List size={32} />}>
            <ViewsDropdownMenu taleId={taleId} />
          </NavItem>
        </div>
        // <div className="w-20 d-flex flex-column align-items-center">
        //   <List size={32} />
        // </div>
      }
      center={
        <div className="w-60 d-flex flex-column align-items-center">
          <div className="tale-title text-center">
            <h4>{tale.title ?? "Itinerary"}</h4>
          </div>
        </div>
      }
      end={
        <div className="w-20 d-flex flex-column align-items-center">
          <img
            src={suitcasePng}
            alt="Packing List"
            width="32"
            height="32"
          ></img>
        </div>
      }
    />
  );
};

export default ViewsHeader;
